<script setup>
import { ref, defineAsyncComponent } from "vue";
import loadAnimationData from "~/assets/images/loading-white.json";
import { useI18n } from "~/composables/useI18n";

const { t } = useI18n();
const lottieReady = ref(false);
const LottieAnimation = defineAsyncComponent(() => import("~/components/lottie-animation.vue"));

defineProps({
	/** fullscreen: 盖住整页；inline: 内容区占位 */
	mode: {
		type: String,
		default: "inline",
		validator: v => ["inline", "fullscreen"].includes(v),
	},
});
</script>

<template>
	<div class="global-page-loading no-vw" :class="`global-page-loading--${mode}`">
		<div class="global-page-loading__box">
			<div v-if="!lottieReady" class="global-page-loading__spinner" aria-hidden="true" />
			<LottieAnimation
				v-show="lottieReady"
				class="global-page-loading__animation"
				:animation-data="loadAnimationData"
				@vue:mounted="lottieReady = true"
			/>
			<p class="global-page-loading__text">{{ t("common.loading") }}</p>
		</div>
	</div>
</template>

<style scoped>
/* no-vw：避免 postcss-px-to-viewport 按 750 稿把 PC 弹层放大 */
.global-page-loading.no-vw {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	box-sizing: border-box;
}

.global-page-loading.no-vw.global-page-loading--inline {
	min-height: 60vh;
	padding: 40px 16px;
}

.global-page-loading.no-vw.global-page-loading--fullscreen {
	position: fixed;
	inset: 0;
	z-index: 9999;
}

.global-page-loading.no-vw .global-page-loading__box {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	width: 182px;
	height: 182px;
	border-radius: 20px;
	background: rgba(0, 0, 0, 0.7);
	box-sizing: border-box;
	overflow: hidden;
	flex-shrink: 0;
}

.global-page-loading.no-vw .global-page-loading__spinner {
	width: 40px;
	height: 40px;
	flex-shrink: 0;
	border: 4px solid rgba(255, 255, 255, 0.25);
	border-top: 4px solid #ffffff;
	border-radius: 50%;
	animation: global-page-loading-spin 1s linear infinite;
}

.global-page-loading.no-vw .global-page-loading__animation {
	width: 94px !important;
	height: 94px !important;
	max-width: 94px;
	max-height: 94px;
	flex-shrink: 0;
	overflow: hidden;
	display: block !important;
	box-sizing: border-box;
}

.global-page-loading.no-vw .global-page-loading__animation :deep(svg) {
	display: block;
	width: 100% !important;
	height: 100% !important;
}

.global-page-loading.no-vw .global-page-loading__text {
	margin: 0;
	flex-shrink: 0;
	color: #ffffff;
	text-align: center;
	font-family: "Source Han Serif CN", "Source Han Serif SC", serif;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}

@keyframes global-page-loading-spin {
	to {
		transform: rotate(360deg);
	}
}
</style>
